import React from 'react'
import { Link } from 'react-router'




export default (props) => {//返回组件
  let title
  let catname
  if (props.title === '产品介绍') {
    title = '借款咨询'
  } else {
    title = props.title
  }

  const parentMenu = props.menu
  var menuList = (parentMenu && parentMenu.children) && parentMenu.children.map((menuItem, i) => {
    let className = ''
    let routerPathname= props.router.location.pathname.split('/')[2]
    let childerName=((routerPathname=='newsinfo' || routerPathname=='news') && menuItem.catname=='news')?routerPathname:menuItem.catname
    if (props.router.isActive(parentMenu.catname + '/' + childerName+(childerName=='newsinfo' || childerName=='loaninfo' ?'/' +props.router.params.id:'')) || (props.router.location.pathname.match(/\//g).length === 1 && i === 0 )) {
      className = 'current'//高亮显示选中的当前路由
      catname=menuItem.catname
    }
    if(menuItem.title=='职位招聘'){
      return false
    }
    return (
      <li key={i} className={className}>
        <a href={props.menuChilderUrl(parentMenu.catname,menuItem.catname,'loaninfo')}>{menuItem.title}</a>
      </li>
    )
  })

  // 首页和新闻详细页, 职位详细页不需要左侧导航
  if (!parentMenu || parentMenu.catname === 'home'
  
  || (props.router.location.pathname.indexOf('/news/') >= 0)
  || props.router.location.pathname.indexOf('/loaninfodetail/') >= 0
  || props.router.location.pathname.indexOf('/jobDetail/') >= 0) {
    return <div></div>
  } else {
    return (
      <div className="leftBar fontbig" >
        <div className="classPre">
          <h2 className={catname=='jobRecruitment'?'current':''}>
          {title=='招贤纳士'?<a href={props.menuChilderUrl('recruitment','jobRecruitment')}>职位招聘</a>:title}
          </h2>
          <ul>
            {menuList}
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/layout/LeftNavigation.js